import styled from "styled-components";

const StyledRadio = styled.label`
    display: inline-block;
    position: relative;
    padding-left: 36px;
    cursor: pointer;
    user-select: none;
    &:not(:last-child) {
        margin-right: 24px;
    }
    input {
        position: absolute;
        opacity: 0;
        cursor: pointer;
        &:checked ~ .checkmark {
            background-color: var(--green1);
            &:after {
                display: block;
            }
        }
    }
    .checkmark {
        position: absolute;
        top: 0;
        left: 0;
        height: 24px;
        width: 24px;
        background-color: #fff;
        border: 2px solid var(--green1);
        border-radius: 50%;
        &:after {
            content: "";
            position: absolute;
            display: none;
            top: 50%;
        	left: 50%;
        	width: 10px;
        	height: 10px;
        	border-radius: 50%;
        	background: #fff;
             transform: translate(-50%, -50%);
        }
    }
`;

export default StyledRadio